import React, { FC } from 'react'

import Table from '../Table'
import productTable from '../../constants/table/productTable'
import useModalForm from '../../hooks/context/useModalForm'
import { Button, Icon } from '@madup-inc/mad-design'
import product from '../../constants/form/product'
import ModalForm from '../Modal/ModalForm'

const Product: FC = () => {
  const { isVisible, setIsVisible, fields, onClickCreate } = useModalForm(productTable.path)

  return (
    <>
      <div
        style={{
          marginBottom: '24px',
          textAlign: 'right',
        }}
      >
        <Button
          ghost
          type="dashed"
          onClick={() => {
            setIsVisible(true)
          }}
        >
          <Icon type="add" />
          Create
        </Button>
      </div>
      <Table table={productTable} />
      <ModalForm
        form={product}
        visible={isVisible}
        handleOK={() => {
          onClickCreate()
        }}
        handleCancel={() => {
          setIsVisible(false)
        }}
        fields={fields}
        title="Create Product"
        okText="Create"
      />
    </>
  )
}

export default Product
